/*
 * Utility Functions
 */

export {
	parseTimestamp,
	zeroPad,
	numFormat,
	yyyymmddToKey,
	priceDiff,
	rangeText,
	queryStringToHash,
	formatDataVersion,
	addSaikoClass,
	getDiffDays,
	replaceHistory,
	dateArrayToHash
};

function parseTimestamp(timestamp, type){
	if(/^(\d{4})\/(\d{2})\/(\d{2})\s(\d{2}):(\d{2}):(\d{2})/.test(timestamp)){
		if(type === "day"){
			return new Date(
				RegExp.$1 - 0
				,RegExp.$2 - 1
				,RegExp.$3 - 0
			);
		}
		return new Date(
			RegExp.$1 - 0
			,RegExp.$2 - 1
			,RegExp.$3 - 0
			,RegExp.$4 - 0
			,RegExp.$5 - 0
			,RegExp.$6 - 0
		);
	}
}

function numFormat(value) {
	return String(value).replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
}


function zeroPad(num) {
	return ("0" + num).slice(-2);
}

function yyyymmddToKey(yyyymmdd) {
	return [
		yyyymmdd.slice(0, 4),
		yyyymmdd.slice(4, 6),
		yyyymmdd.slice(6, 8)
	].join("-");
}

function priceDiff(fm, to, delim) {
	var a = parseInt(fm, 10); var b = parseInt(to, 10);
	var min = "" + (a < b ? a : b);
	var max = "" + (a > b ? a : b);
	return comma3WithSign(min) + (min === max ? "" : delim + comma3WithSign(max));
}

function comma3WithSign(v) {
	if (v === 0) {
		return "&plusmn;0";
	} else if (v > 0) {
		return "+" + numFormat(v);
	} else {
		return numFormat(v);
	}
}

function rangeText(min, max, text = "〜") {
	return (min !== max ) ? [min, max].join(text) : min;
}

function queryStringToHash(str, func=defaultDecoder) {
	return str.split("&")
		.map((v) => v.split("="))
		.filter((v) => v[1] != null && v[1] !== "")
		.reduce((a, b) => (
			Object.assign(a, {[b[0]]: func(b[1])})
		), {});
}

function defaultDecoder(value) {
	// "-"区切りの場合はArrayにする
	// Arrayと通常の値と区別できるよう最後にも"-"が入っているものをArrayとする
	if (value.match(/^(\w+-)+$/) ) {
		return value.split("-")
			.filter((val)=>(val !== "")).map(decodeURIComponent);
	}
	return decodeURIComponent(value);
}

// TODO: PCのコピー。共有する。
function formatDataVersion(version) {
	var s = "";
	if(version && version.match(/(\d{4})\/(\d{2})\/(\d{2})\s+(\d{2}):(\d{2})/)){
		s = RegExp.$2 + "月" + RegExp.$3 + "日 " + RegExp.$4 + ":" + RegExp.$5;
	}
	return s;
}

export function calcDayOffset(dataVersion, decodeTime) {
	// TODO: PCのコピー。共有する。
	const ts1 = parseTimestamp(dataVersion, "day");
	const ts2 = parseTimestamp(decodeTime, "day");
	let day_offset = 0;
	if(ts1 && ts2){
		day_offset = parseInt((ts2.getTime() - ts1.getTime()) / (24 * 60 * 60 * 1000));
		if(day_offset < 0){
			day_offset = 0;
		}
	}
	return day_offset;
}

function addSaikoClass(saikoIndex, withTourConductor, isSelectable){
	if(saikoIndex === "4" && isSelectable){
		return "depart";
	} else if (saikoIndex === "2" && withTourConductor === "true" && isSelectable) {
		return "twoPeople";
	} else {
		return "";
	}
}

function getDiffDays(dataVersion, dateCode, type) {
	if(dataVersion && dataVersion.match(/(\d{4})\/(\d{2})\/(\d{2})\s+(\d{2}):(\d{2})/)){
		var currentDate = new Date(Number(RegExp.$1), Number(RegExp.$2) - 1, Number(RegExp.$3));
	}
	var deptDate;
	if(type === "courseCal"){
		if(dateCode && dateCode.match(/(\d{4})-(\d{2})-(\d{2})/)){
			deptDate = new Date(Number(RegExp.$1), Number(RegExp.$2) - 1, Number(RegExp.$3));
		}
	} else if(type === "detailCal") {
		deptDate = new Date(Number(dateCode.substr(0,4)), Number(dateCode.substr(4,2)) - 1, Number(dateCode.substr(6,2)));
	}

	var diffDays = ((deptDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));
	return diffDays;
}

function replaceHistory() {
	//JALINTL-771 iOS/safariでの不具合対応: 該当条件のみhistoryAPIの挙動が異なることへの対応
	if (history && history.replaceState && history.state !== undefined) {
		history.replaceState(null, null, location.href);
	}
}

function dateArrayToHash(dates) {
	var dateHash = {};
	for (var i = 0; i < dates.length; i++) {
		var key = yyyymmddToKey(dates[i].code);
		dateHash[key] = dates[i];
		dateHash[key].index = i;
		dateHash[key].year = key.split("-")[0];
	}

	return dateHash;
}



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/modules/util.js